import { Box, Grid } from "@mui/material";
import { TutorialDto, TutorialService } from "../../../api/psc";
import {
    DialogContainer,
    DialogHeader,
    EmptyListMessage,
    Spinner,
} from "../../../components/exports";
import useDynamicList from "../../../hooks/UseDynamicList";
import TutorialItem from "../components/TutorialItem";

export default function TutorialCategoryDialog(props: { tag: string }) {
    const manager = useDynamicList<TutorialDto>(async (offset) => {
        return TutorialService.listTutorials("1");
    });

    if (manager.requestInProgress) {
        return <Spinner />;
    }

    const tutorialCategories = manager.results.filter((t) =>
        t.tag.includes(props.tag)
    );

    return (
        <DialogContainer preferredWith={650}>
            <DialogHeader title="لیست ویدیو های آموزشی" />

            <Box sx={{ p: 2, bgcolor: "background.default" }}>
                {tutorialCategories.length === 0 && (
                    <EmptyListMessage message="ویدیوی آموزشی برای این بخش یافت نشد!" />
                )}

                <Grid container spacing={2}>
                    {tutorialCategories.map((t) => (
                        <Grid item xs={12} sm={12} md={6} key={t.id}>
                            <TutorialItem item={t} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </DialogContainer>
    );
}
